module.exports = __webpack_public_path__ + "static/media/sell.65ea9862.svg";